import * as Yup from 'yup';
import omit from 'lodash/omit';
import { SignUpPageStrings } from '../../../common/localization/en';
import { SignUpConfig } from '../../../api/models/venue';

// Styles have been migrated to MagicLinkForm.styles.ts

const phoneRegExp =
  /^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,3})|(\(?\d{2,3}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/;

const iso88591Regex = /^[\x00-\xFF]*$/;

export const emailValidationSchema = Yup.string().email('Please enter a valid email format');

export const getValidationSchema = (
  config: { email?: boolean; firstName?: boolean; lastName?: boolean; phoneNumber?: boolean } = {
    email: true,
    firstName: true,
    lastName: true,
    phoneNumber: true,
  },
) => {
  const baseValidationObject = {
    firstName: Yup.string()
      .trim()
      .max(100, 'max length 100 symbols')
      .matches(iso88591Regex, 'First name contains invalid characters.')
      .required('First name is required'),
    lastName: Yup.string()
      .trim()
      .max(100, 'max length 100 symbols')
      .matches(iso88591Regex, 'Last name contains invalid characters.')
      .required('Last name is required'),
    // email: Yup.string().matches(emailMaskRegex, 'Email is not valid').required('Email is required'),
    email: emailValidationSchema.required('Email is required'),
    phoneNumber: Yup.string()
      .required('Phone number is required')
      .min(7, 'Phone number is not valid')
      .matches(phoneRegExp, 'Phone number is not valid')
      .nullable(),
  };

  const disabledValues = Object.entries(config)
    .filter(([_, value]) => value === false)
    .map(([key]) => key);

  return Yup.object().shape(omit(baseValidationObject, disabledValues));
};

export const ValidationSchemaPhone = () => {
  return Yup.object().shape({
    phoneNumber: Yup.string()
      .required('Phone number is required')
      .min(7, 'Phone number is not valid')
      .matches(phoneRegExp, 'Phone number is not valid'),
  });
};

export const getFormData = (submitButtonName: string, isSignUp: boolean, signUpConfig: SignUpConfig) => {
  return {
    isNameField: isSignUp,
    isEmailField: false,
    isPhoneField: !isSignUp,
    submitButtonName,
    passwordPlaceholder: SignUpPageStrings.Password,
    formName: SignUpPageStrings.SignUp,
    text: SignUpPageStrings.Login,
    authValidationSchema: isSignUp
      ? getValidationSchema({
          phoneNumber: !!signUpConfig?.phoneRequired,
          firstName: !!signUpConfig?.nameRequired,
          lastName: !!signUpConfig?.nameRequired,
          email: !!signUpConfig?.emailRequired,
        })
      : ValidationSchemaPhone,
    isTermsOfService: true,
    analyticsText: {
      action: SignUpPageStrings.RedirectedText,
      buttonName: SignUpPageStrings.SignUp,
    },
  };
};
